import { render, staticRenderFns } from "./dashboard-template.vue?vue&type=template&id=77bec3fc&"
import script from "./dashboard-template.vue?vue&type=script&lang=ts&"
export * from "./dashboard-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports